export default __webpack_public_path__ + "static/media/undraw_online_resume_re_ru7s.4b1106b8.svg";